// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__XA-_8","arrow":"styles_arrow__2fhI5"};